/* eslint-disable quotes */
export default {
  in_game_label: 'InGame',
  // 注：站点切换
  english_label: 'English',
  international_remark: 'International',
  simplified_chinese_label: '简体中文',
  china_site_remark: '中国站',

  product_document_title: 'Product Document',

  // 区域
  european_label_type: 'Europe(Frankfurt)',
  asian_label_type: 'Asia Pacific(Singapore)',
  north_label_type: 'North America(Virginia)',
  east_label_type: 'East China(Shanghai)',
  woa_label_type: 'Woa',
  dev_cloud_label_type: 'DevCloud(Nanjing)',
  idc_label_type: 'IDC(Nanjing)',

  account_label: 'Account',
  sign_out_label: 'Sign Out',
  download_center: 'Download Center',

  create_title_success_desc: 'You have successfully created a new title.',
  creation_fail_try: 'Creation Failed. Please try again.',
  exceed_limit_10: 'Exceed the limit of 10.',
  use_least_10: 'Use at least 10 characters.',
  max_72: 'Maximum 72 characters.',
  no_different_password:
    'There is no difference between old and new passwords.',
  use_correct_email_format: 'Please use the correct email format.',
  incorrect_format: ' Incorrect format',
  no_spaces: 'No spaces.',
  required: 'Required',
  field_type_message: 'Field type {{type}}',
  field_length_message: 'Field length not greater than {{maxLen}}',
  please_stronger_password:
    'Please choose a stronger password. Try a mix of letters, numbers, and symbols.',
  new_title: 'New Title',
  new_title_form_label: 'New Title',
  code_name_form_label: 'Code Name',
  please_enter_title_name: 'Please enter your title name',
  please_enter_code_name: 'Please enter your code name',
  region_is_required: 'Main site is required.',
  code_is_required:
    'Must be a combination of uppercase and lowercase letters and numbers, cannot start with a number, contain no spaces, and be 9 characters or fewer.',
  please_select_the_region: 'Please select the main site',
  region_default_env_desc:
    'The main site you select is the default environment deployment  main site for this title.',
  title_unique_code:
    'The unique identifier of this game cannot be modified once it is created.',
  message_center: 'Message Center',
  view_more: 'View More',
  type_something_search: 'Type something to search',
  to_navigate: 'to navigate',
  to_select: 'to select',
  results: 'Results',
  no_result: 'No result',
  search_ellipsis: 'Search...',
  search_ingame_docs: 'Search InGame Docs',
  dev_portal: 'Dev Portal',
  account_center: 'Account Center',
  back_to_studio: 'Back to Studio',

  // 消息-除去config.ts
  notifications_as_read: 'Notifications as read.',
  no_unread_notifications: 'No unread notifications',
  notice_type: 'Notice',
  mark_as_read: 'Mark As Read',
  un_reads: 'Unreads',

  studio_name_and_id: '{{studioStr}}',
  owner_transfer_notification_content:
    'The owner of the studio has been transferred. Your current role in the organization is {{authority}}.',
  permission_change_become_admin_content:
    'Your permissions in this studio have been changed. Your current role is Admin.',
  action_added_type: 'added',
  action_removed_type: 'removed',
  permission_change_content:
    'Your permissions in this studio have been changed.',
  permission_change_user_groups_content:
    'You have been {{action}} the group "{{groups}}" on {{changeDate}}. Please visit the organization management page for more details.',
  group_permission_change_content:
    'The permissions of your group "{{groups}}" have been changed on {{changeDate}}. Please visit the organization management page for more details.',
  group_scope_change_content:
    'The scope of your group "{{groups}}" have been changed on {{changeDate}}. Please visit the organization management page for more details.',
  permission_studio_delete_content:
    'We regret to inform you that your studio "{{studioName}}" has been deleted on {{deletionDate}}. You have been automatically removed from this studio. For more information, please reach out to the studio owner.',
  permission_game_delete_content:
    'We regret to inform you that the game "{{gameName}}" of your user group has been deleted on {{deletionDate}}. Please visit the organization management page for more details.',
  permission_env_delete_content:
    'We regret to inform you that the environment "{{envName}}" of your user group has been deleted on {{deletionDate}}. Please visit the organization management page for more details.',
  // update_authority_message:
  //   'Please be informed that your authority level within the studio, {{studioStr}}, has been updated to that of an {{authority}}.',
  the_applicant: 'The applicant, ',
  // applicant_request_message: 'The applicant, {{applicant}} ({{applicantUserID}}), has submitted a request to join the organization. The reason provided for the application is as follows: {{reason}}.',
  has_join_organization_reason_desc1:
    'The applicant, {{applicant}} ({{applicantUserID}}) has submitted a request to join the organization: {{studioStr}}. The reason provided for the application is as follows:',
  has_join_organization_reason_desc2: '',
  go_to_join_organization_page_handle: '',
  application_approved_message:
    'We are pleased to inform you that your application to join the studio {{studioStr}} has been approved.',
  application_rejected_message:
    'We regret to inform you that your application to join the studio {{studioStr}}  has been rejected.',
  regret_inform_remove_message:
    'We regret to inform you that you have been removed from the studio {{studioStr}} .',
  admin_invite_member_success:
    'We are pleased to inform you that you have been successfully invited to join the studio {{studioStr}} .',
  success_exited_studio:
    'You have successfully exited the studio {{studioStr}}.',
  respect_user: '',
  service_open_success_inform1:
    "We are delighted to inform you that your request for the activation of the {{serviceName}} in the {{envName}} of {{gameName}} has been approved. The service is now available for your use. We hope you enjoy the enhanced gaming experience this service provides. If you have any questions or need further assistance, please don't hesitate to contact us.",
  service_open_success_inform2: '',
  service_open_success_inform3: '',
  service_open_fail_inform1:
    "We regret to inform you that your request for the activation of the {{serviceName}} in the {{envName}} of {{gameName}} has been denied. If you have any questions or need further assistance, please don't hesitate to contact us.",
  service_open_fail_inform2: '',
  demo_test: 'Demo Test',
  company_authentication_success_content:
    'The enterprise authentication of the studio has been approved. You can view the details on the Studio/Basic Information page.',
  company_authentication_fail_content:
    'We regret to inform you that the enterprise authentication of the studio has not been approved. Please visit the Studio/Basic Information page for more details.',
  account_balance_warm:
    'As of {{createTime}}, the balance of your account is lower than the set balance warning threshold. If the account enters an arrears state, it will affect the normal use of platform functions. Please recharge in time or pay attention to backing up data to avoid affecting your normal operations.',

  service_apply_inner_service:
    'the {{ServiceName}} in the {{EnvName}} of {{GameName}}',
  service_apply_pending_content:
    'Thank you for submitting following service applications: <br /> {{content}} <br /> We have received the corresponding requests. The service deployment and approval are expected to be completed within 48 hours. Thank you for your patience!',
  service_apply_reject_content:
    "We regret to inform you that your request for the activation of following services has been denied. <br /> {{content}} <br /> If you have any questions or need further assistance, please don't hesitate to contact us.",
  service_apply_success_content:
    "We are delighted to inform you that your request for the activation of following services has been approved. <br /> {{content}} <br /> The service is now available for your use. We hope you enjoy the enhanced gaming experience this service provides. If you have any questions or need further assistance, please don't hesitate to contact us.",
};
